import apiService from './api';
import type { AdminProductContext, SetAdminProductContextPayload } from '@/types';

const ADMIN_PRODUCT_CONTEXT_PATH = '/admin/product-context';

class ProductService {
  getAdminProductContext = async () => {
    const response = await apiService.get<AdminProductContext>(ADMIN_PRODUCT_CONTEXT_PATH);
    return response.data;
  };

  setAdminProductContext = async (payload: SetAdminProductContextPayload) => {
    const response = await apiService.post<AdminProductContext>(ADMIN_PRODUCT_CONTEXT_PATH, payload);
    return response.data;
  };
}

export default new ProductService();
